import { QueryClient } from "@tanstack/react-query";
import { CatImport, CatImportRst, Category } from "../types/category";
import { get, post } from "./fetch.core";
import { initPromise } from "./init.core";

export async function getCategories() {
  await initPromise;
  const res = await get<Category[]>("/admin/category/list");
  return res.data;
}

export async function getSingleCategory(id: string) {
  await initPromise;
  const res = await get<Category>(`/admin/category/get?id=${id}`);
  return res.data;
}

export async function addCategory(data: any) {
  if (data.parentId === "") {
    data.parentId = undefined;
  }
  if (data.rewardPayout === "") {
    data.rewardPayout = undefined;
  }

  await post("/admin/category/create", data);
}

export async function editCategory(data: any) {
  if (!data.parentId) {
    data.parentId = undefined;
  }
  if (data.rewardPayout === "") {
    data.rewardPayout = undefined;
  }

  // delete data.code;

  await post("/admin/category/edit", data);
}

export async function deleteCategory(id: string) {
  const res = await post("/admin/category/delete", { id });
  return res.data;
}

export async function deleteCategories(ids: string[], queryClient: QueryClient) {
  await Promise.all(ids.map((id) => deleteCategory(id)));
  queryClient.invalidateQueries({ queryKey: ["categories"] });
}

export function groupByParent(categories: Category[]): Category[] {
  categories = [...categories];

  for (var i = 0; i < categories.length; i++) {
    const cat = categories[i];
    if (cat.parentId === undefined) continue;

    // find the parent
    const parentCat = categories.find((c) => c.id === cat.parentId);
    if (parentCat === undefined) continue;

    if (parentCat.children === undefined) {
      parentCat.children = [];
    }

    // don't add if already exist
    const childFound = parentCat.children.find((c) => c.id === cat.id);
    if (!childFound) {
      parentCat.children.push(cat);
      cat.parent = parentCat;
    }
  }

  // now the tree is built.  remove those children from the first level
  return categories.filter((c) => c.parentId === undefined);
}

export async function importCats(catImports: CatImport[]) {
  const rst = await post<CatImportRst[]>("/admin/category/import", { cats: catImports });
  return rst.data;
}

export async function editPosition(
  id: string,
  parentId: string | undefined,
  afterId: string | undefined,
  queryClient: QueryClient
) {
  await post("/admin/category/editPosition", {
    id,
    parentId,
    afterId,
  });

  queryClient.invalidateQueries({ queryKey: ["categories"] });
}
